import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

export interface ChatMetricsDataItem {
  date: string
  generalMetrics: Record<string, number>
  latencyMetrics: Record<string, number>
}

export interface ChatDispositionItem {
  date: string
  rawDispositions: Record<string, number>
}

export interface ChatDurationItem {
  date: string
  metrics: Record<string, number>
}

export interface ChatDashboardResponse {
  campaign: { id: number; name: string; telephony: string | null }
  metricsData: ChatMetricsDataItem[]
  dispositionMetrics: ChatDispositionItem[]
  durationMetrics: ChatDurationItem[]
}

export interface ChatCampaignDatesResponse {
  startDate: string
  endDate: string
}

export function useChatCampaignDates(campaignId: number | null) {
  const apiClient = useApiClient()
  return useQuery({
    queryKey: ['chat-campaign-dates', campaignId],
    queryFn: async () => apiClient<ChatCampaignDatesResponse>(`/dashboard-chat/dates?campaign_id=${campaignId}`),
    enabled: !!campaignId && campaignId > 0,
  })
}

export function useChatDashboardMetrics(
  campaignId: number | null,
  startDate: string | null,
  endDate: string | null,
) {
  const apiClient = useApiClient()
  return useQuery({
    queryKey: ['chat-dashboard-metrics', campaignId, startDate, endDate],
    queryFn: async () => {
      const params = new URLSearchParams({
        campaign_id: String(campaignId),
        start_date: startDate!,
        end_date: endDate!,
      })
      return apiClient<ChatDashboardResponse>(`/dashboard-chat/metrics?${params}`)
    },
    enabled: !!campaignId && !!startDate && !!endDate,
    staleTime: 1000 * 60 * 5,
  })
}
